import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api.service';
import type { FormatLocale } from '../services/tenantConfig.service';

export interface Whitelabeling {
  enabled?: boolean;
  logo_path?: string;
  favicon_path?: string;
  page_title?: string;
  primary_cta_color?: string;
  brand_color?: string;
  brand_dark_color?: string;
  // frontend2 theme overrides (hex colors)
  primary_color?: string;
  secondary_color?: string;
  chart_1_color?: string;
  chart_2_color?: string;
  chart_3_color?: string;
  chart_4_color?: string;
  chart_5_color?: string;
}

export interface TenantConfig {
  id: string;
  tenant_slug: string;
  tenant_uuid: string;
  whitelabeling?: Whitelabeling;
  format_locale?: FormatLocale;
  [key: string]: any; // Allow other properties
}

export function useTenantConfig() {
  return useQuery<TenantConfig>({
    queryKey: ['tenantConfig'],
    queryFn: async () => {
      const data = await ApiService.getInstance().request('GET', '/config');
      return data as TenantConfig;
    },
    staleTime: 30 * 60 * 1000, // 30 minutes
    retry: 1,
  });
}

